
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'CheckBox',

  props: {
    /** 双向绑定值 */
    modelValue: {type: Boolean, default: false},

    /** 复选框勾选状态不确定是传入此参数 */
    indeterminate: {type: Boolean, default: false}
  },

  setup(props, {emit}) {
    return {
      onClick(event: PointerEvent) {
        event.preventDefault();
        event.stopPropagation();

        const element = (event.target as HTMLElement).closest('.check-box');
        const disabled = (element as HTMLElement).getAttribute('data-disabled');

        disabled !== 'true' && emit('update:modelValue', !props.modelValue);
      }
    }
  }

});
